import { inject as service } from '@ember/service';
import AdapterError from '@ember-data/adapter/error';
import JSONAPIAdapter from '@ember-data/adapter/json-api';
import NestedResourceMixin from 'sh-www/mixins/nested-resource-mixin';
import { normalizeErrors } from 'sh-www/utils/adapter-errors';

import config from 'sh-www/config/environment';

class ApplicationJSONAPIAdapter extends JSONAPIAdapter.extend(NestedResourceMixin) {
  @service session;

  sessionHeaders = {};

  get host() {
    return config.apiUrl;
  }

  /** @inheritDoc */
  get headers() {
    const headers = { ...this.sessionHeaders };

    if (this.session.isMasquerading) {
      headers.Masquerade = '1';
    }

    return headers;
  }

  async ajax(url, type) {
    this.sessionHeaders = await this.session.sessionHeaders(type);

    return super.ajax(...arguments);
  }

  /** @inheritDoc */
  ajaxOptions() {
    const hash = super.ajaxOptions(...arguments);

    hash.credentials = 'include';
    hash.cache = 'no-cache';

    return hash;
  }

  /** @inheritDoc */
  shouldReloadRecord() {
    return true;
  }

  /** @inheritDoc */
  isSuccess(_, __, payload) {
    return super.isSuccess(...arguments) && (payload?.data?.type !== 'Error');
  }

  /** @inheritDoc */
  handleResponse(status, headers, payload, requestData) {
    if (this.isSuccess(status, headers, payload)) {
      return payload;
    }

    const errors = this.normalizeErrorResponse(status, headers, payload);
    const detailedMessage = this.generatedDetailedMessage(status, headers, payload, requestData)
    const adapterStatus = payload.data?.attributes?.['status-code'] || status;

    const adapterError = new AdapterError(errors, detailedMessage);
    adapterError.status = adapterStatus;

    return adapterError;
  }

  /** @inheritDoc */
  normalizeErrorResponse(_, __, payload) {
    return normalizeErrors(payload);
  }
}

export default ApplicationJSONAPIAdapter;
